<template>
    <div>
        <div v-if="items.length" class="">
            <span v-for="(item, index) in items"
                style="white-space: wrap;" class="me-2 text-start my-2 fs-6 badge bg-soft-primary text-primary" :key="index">
            <span v-if="item.category"> {{ item.category.title }} - </span> ({{ item.question_quota }}) </span>
        </div>
        <div v-else class="text-muted">Not applicable</div>
    </div> 
  </template>
  
  <script>
  export default {
      props:{
        items: {
            type: Array,
        }
      }
  }
  </script>
  
  <style>
  
  </style>